export default "__VITE_ASSET__CD06SuTF__"